export default {
  GET_VISIT_TYPES: {
    MOBILE: {
      ERROR: {
        severity: 'error' as 'error',
        title: 'Uh oh!',
        description:
          'Sorry, there was an issue fetching the list of visit types. Pull down to refresh and try again.'
      }
    },
    WEB: {
      ERROR: {
        severity: 'error' as 'error',
        title: 'Uh oh!',
        description: 'Sorry, there was an issue fetching the list of visit types.'
      }
    },
    NO_DATA: {
      message:
        'This provider does not have availability online at this time, please call the clinic for an appointment.'
    },
    NO_SLOTS_AVAILABLE: {
      message:
        'There is a problem with scheduling with this provider online. Please call the clinic to get the care you need.'
    },
    NO_RELATIONSHIP_WITH_PROVIDER: {
      message:
        'The chosen patient has not seen this provider within the past 3 years, which they require for online scheduling. Call the clinic for more care options.'
    },
    SERVICE_DOWN: {
      message: 'There is a problem with online scheduling at this time. Please try again later.'
    },
    BEHAVIORAL_HEALTH_INFO: {
      message:
        'If your needs are urgent or you feel like you are in crisis, please call 988 to be connected to America’s Suicide Prevention and Mental Health Crisis Lifeline or visit your nearest Emergency Room. Online scheduling is for routine, non-urgent behavioral health appointments.'
    },
    OPHTHALMOLOGIC_INFO: {
      message:
        'For glasses/contacts appointments or if you are experiencing any issues with blurriness, vision changes, redness, and/or flashes of light please call the clinic to schedule.',
      popupMessage:
        'Please bring your glasses/contacts to this appointment. your eyes will be dilated so plan on being in the office 75-90 min.'
    }
  }
};
